import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import { CgMail } from "react-icons/cg";
import { FaXTwitter } from "react-icons/fa6";
import { FaGithub } from "react-icons/fa";
import { FaLinkedinIn } from "react-icons/fa"


import "./styles.css"

const Header = () => {

  //i use here useLocation()hooks for show the current active path
  const location = useLocation()

  // console.log(location.pathname)

  const [isScreenSmall, setIsScreenSmall] = useState(window.innerWidth <= 700);
  const [showSidebar, setShowSidebar] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsScreenSmall(window.innerWidth <= 700);

      // Reset sidebar state when switching screen sizes
      if (window.innerWidth > 700) {
        setShowSidebar(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setShowSidebar((prevState) => !prevState);
  };

  return (
    <header>
      <nav className="navbar">
        <div className="navbar-logo">
          <Link to="/" className="logo-link">Amresh</Link>
        </div>
        {isScreenSmall && (
          <div className="menu-bars" onClick={toggleSidebar}>
            <FaIcons.FaBars />
          </div>
        )}

        {/* Navbar List for Large Screens */}
        {!isScreenSmall && (
          <ul className="navbar-list">
            <li>
              <Link to="/Homepage" className={location.pathname === '/Homepage' ? 'active-link' : ''} onClick={toggleSidebar}>
                Home
              </Link>
              {location.pathname === '/Homepage' && <hr className="active-hr" />}
            </li>
            <li>
              <Link to="/Projects" className={location.pathname === '/Projects' ? 'active-link' : ''} onClick={toggleSidebar}>
                Projects
              </Link>
              {location.pathname === '/Projects' && <hr className="active-hr" />}
            </li>
            <li>
              <Link to="/web-apps" className={location.pathname === '/web-apps' ? 'active-link' : ''} onClick={toggleSidebar}>
                Web Apps
              </Link>
              {location.pathname === '/web-apps' && <hr className="active-hr" />}
            </li>
            <li>
              <Link to="/Resume" className={location.pathname === '/Resume' ? 'active-link' : ''} onClick={toggleSidebar}>
                Resume
              </Link>
              {location.pathname === '/Resume' && <hr className="active-hr" />}
            </li>
            <li>
              <Link to="/Contact" className={location.pathname === '/Contact' ? 'active-link' : ''} onClick={toggleSidebar}>
                Contact
              </Link>
              {location.pathname === '/Contact' && <hr className="active-hr" />}
            </li>
            <li>
              <a
                href="mailto:amreshbkp0111@gmail.com"
                target="_blank"
                onClick={toggleSidebar}
                rel="noreferrer"
              >
                <CgMail className="icons" style={{ fontSize: '1.8rem' }} />

              </a>
            </li>
            <li>
              <a
                href="https://github.com/amresh1kumar"
                target="_blank"
                onClick={toggleSidebar}
                rel="noreferrer"
              >

                <FaGithub className="icons" />
              </a>
            </li>
            <li>
              <a
                href="https://x.com/amresh1kumar"
                target="_blank"
                onClick={toggleSidebar}
                rel="noreferrer"
              >

                <FaXTwitter className="icons" style={{ fontSize: '1.3rem' }} />
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/in/amresh1kumar/"
                target="_blank"
                onClick={toggleSidebar}
                rel="noreferrer"
              >
                <FaLinkedinIn className="icons" />
              </a>
            </li>
          </ul>
        )}

        {/* Sidebar for Small Screens */}
        {isScreenSmall && (
          <nav className={showSidebar ? "nav-menu active" : "nav-menu"}>
            {/* Close Button */}
            <div className="close-button">
              <AiIcons.AiOutlineClose onClick={toggleSidebar} />
            </div>

            <ul className="nav-menu-items">
              <li className="nav-item-1">
                <Link to="/Homepage" className={location.pathname === '/Homepage' ? 'active-link' : ''} onClick={toggleSidebar}>
                  Home
                </Link>

              </li>
              <li className="nav-item-2">
                <Link to="/Projects" className={location.pathname === '/Projects' ? 'active-link' : ''} onClick={toggleSidebar}>
                  Projects
                </Link>
              </li>
              <li className="nav-item-2">
                <Link to="/web-apps" className={location.pathname === '/Projects' ? 'active-link' : ''} onClick={toggleSidebar}>
                  Web Apps
                </Link>
              </li>
              <li className="nav-item-3">
                <Link to="/Resume" className={location.pathname === '/Resume' ? 'active-link' : ''} onClick={toggleSidebar}>
                  Resume
                </Link>
              </li>
              <li className="nav-item-3">
                <Link to="/Contact" className={location.pathname === '/Contact' ? 'active-link' : ''} onClick={toggleSidebar}>
                  Contact
                </Link>
              </li>
              <li className="nav-item-4">
                <a
                  href="mailto:amreshbkp0111@gmail.com"
                  onClick={toggleSidebar}
                  rel="noreferrer"
                >
                  <CgMail className="icons" style={{ fontSize: '1.9rem' }} />
                </a>
              </li>
              <li className="nav-item-5">
                <a
                  href="https://github.com/amresh1kumar"
                  target="new"
                  onClick={toggleSidebar}
                  rel="noreferrer"
                >
                  <FaGithub className="icons" />
                </a>
              </li>
              <li className="nav-item-6">
                <a
                  href="https://x.com/amresh1kumar"
                  target="new"
                  onClick={toggleSidebar}
                  rel="noreferrer"
                >
                  <FaXTwitter className="icons" style={{ fontSize: '1.3rem' }} />
                </a>
              </li>
              <li className="nav-item-7">
                <a
                  href="https://www.linkedin.com/in/amresh1kumar/"
                  target="new"
                  onClick={toggleSidebar}
                  rel="noreferrer"
                >
                  <FaLinkedinIn className="icons" />
                </a>
              </li>
            </ul>
          </nav>
        )}
      </nav>
    </header>
  );
};

export default Header;
